<template>
<div class="inpBox">
   <div class="detailsTitle">
      <h4>货源详情</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
   <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform"   class="demo-form-inline" label-width="110px" size="mini">
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-envelope iconFont" aria-hidden="true"></i>收发货信息</span>
        </h4>
        <div>
            <el-form-item  class="is-required danwei" label="发货单位:" prop="deliverCompany">
            <el-input  placeholder="" maxlength="20" :readonly="true"  v-model="goodform.deliverCompany"></el-input>
          </el-form-item>
          <el-form-item    class="is-required" label="发货人:" prop="deliverPerson">
            <el-input  placeholder=""  maxlength="10" :readonly="true"  v-model="goodform.deliverPerson"></el-input>
          </el-form-item>
          <el-form-item label="发货人电话:" class="is-required" prop="deliverPhone">
            <el-input  placeholder="" maxlength="11" :readonly="true"  type="tel" v-model="goodform.deliverPhone"></el-input>
          </el-form-item>
          <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1">
            <el-input  placeholder=""  maxlength="11" :readonly="true"  v-model="goodform.deliverAddress"></el-input>
          </el-form-item>

        </div>
        <div>
          <el-form-item label="收货单位:" prop="receivingCompany" class="danwei">
          <el-input  placeholder=""  maxlength="20" :readonly="true"  v-model="goodform.receivingCompany"></el-input>
        </el-form-item>
        <el-form-item  label="收货人:" prop="receivingPerson">
          <el-input  placeholder=""  maxlength="10" :readonly="true"  v-model="goodform.receivingPerson"></el-input>
        </el-form-item>
        <el-form-item label="收货人电话:" prop="receivingPhone">
          <el-input  placeholder="" maxlength="11" :readonly="true"  type="tel" v-model="goodform.receivingPhone"></el-input>
        </el-form-item>
          <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1">
          <el-input  placeholder=""  maxlength="11" :readonly="true"  v-model="goodform.receivingAddress"></el-input>
        </el-form-item>

        </div>
      </div>
      <hr>
      <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
        </h4>
        <div>
           <el-form-item label="货物名称:" prop="productName">
        <el-input  placeholder="" maxlength="50"  :readonly="true"    v-model="goodform.productName"></el-input>
      </el-form-item>
       <el-form-item label="货物类型:"  class="jiage" prop="productType">
        <el-input  placeholder="" v-number-input.float="3" :readonly="true"    maxlength="8"  v-model="goodform.productTypeName"></el-input>
      </el-form-item>
      <el-form-item label="货物长度:"  class="jiage"  prop="productLong">
        <el-input  placeholder=""  v-number-input.float="3" :readonly="true"   maxlength="8" v-model="goodform.productLong"></el-input><span class="danwei">米</span>
      </el-form-item>
       <el-form-item label="货物宽度:"  class="jiage" prop="productWide">
        <el-input  placeholder=""  v-number-input.float="3" :readonly="true"  maxlength="8" v-model="goodform.productWide"></el-input><span class="danwei">米</span>
      </el-form-item>
       <el-form-item label="货物高度:"  class="jiage" prop="productHigh">
        <el-input  placeholder="" v-number-input.float="3"  :readonly="true"  maxlength="8"  v-model="goodform.productHigh"></el-input><span class="danwei">米</span>
      </el-form-item>
      <el-form-item label="货物件数:"  class="jiage" prop="productNum">
        <el-input  placeholder="" v-number-input.float="0" :readonly="true"   maxlength="10"   v-model="goodform.productNum"></el-input><span class="danwei">件</span>
      </el-form-item>
      <el-form-item label="货物总重:"  class="jiage" prop="allWeight">
        <el-input  placeholder="" v-number-input.float="3" :readonly="true"    maxlength="8"  v-model="goodform.allWeight"></el-input><span class="danwei">吨</span>
      </el-form-item>
      <el-form-item label="" class="mar10">
        总体积:<span class="red">{{goodform.productVolume}}</span>立方米
      </el-form-item>
        </div>
      </div>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-calculator iconFont" aria-hidden="true"></i>相关费用</span>
        </h4>
        <div>
        <el-form-item label="计价方式 :" prop="pricingMethod" class="jiage">
        <el-select  v-model="goodform.pricingMethod" disabled placeholder="" >
          <el-option v-for="val in jjfangshi" :label="val.name" :value="val.val" :key="val.val"></el-option>
          <!-- <el-option label="区域二" value="beijing"></el-option> -->
        </el-select>
      </el-form-item>

      <el-form-item label="单价:" class="jiage" prop="price" v-if="goodform.pricingMethod==''||goodform.pricingMethod==2?false:true">
    <el-input  placeholder=""  v-number-input.float="2"  :readonly="true"  maxlength="8" v-model="goodform.price"  ></el-input>
  </el-form-item>
  <el-form-item label="包车价:" class="jiage" prop="price" v-if="goodform.pricingMethod==''||goodform.pricingMethod==1?false:true">
    <el-input  placeholder=""  v-number-input.float="2" :readonly="true"  maxlength="8" v-model="goodform.price" ></el-input><span class="danwei">元</span>
  </el-form-item>
        <el-form-item label="仓储费:" prop="storagePrice" class="jiage">
        <el-input  placeholder="" maxlength="11"  :readonly="true" v-model="goodform.storagePrice"></el-input><span class="danwei">元</span>
      </el-form-item>
      <el-form-item label="支付方式 :" prop="paymentType" class="jiage">
        <el-select  v-model="goodform.paymentType" disabled  placeholder="">
          <el-option v-for="val in jsfangshi" :label="val.name" :value="val.val" :key="val.val"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" class="mar10">
        合计费用:<span class="red">{{goodform.allPrice}}</span>元
      </el-form-item>
      </div>
      </div>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>其他信息</span>
        </h4>
        <div>

      <el-form-item label="期望发货时间:" prop="hopeDeliverDate">
            <el-date-picker
              v-model="goodform.hopeDeliverDate"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetime"
              :readonly="true"
                placeholder=""

            ></el-date-picker>
      </el-form-item>
      <el-form-item label="期望到货时间:" prop="hopeReceivingDate">
            <el-date-picker
              v-model="goodform.hopeReceivingDate"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetime"
              :readonly="true"
                placeholder=""

            ></el-date-picker>
      </el-form-item>
      <div>
          <el-form-item label="备注:" class="remark" prop="remark" >
            <el-input  placeholder="" :readonly="true"  maxlength="500" v-model="goodform.remark"></el-input>
          </el-form-item>
      </div>
      <div class="imgBox">
         <ul>
           <li v-for="(item,index)  in goodform.sBillFileList" @click="lookImg(index)" :key="item.id"><img width="100%" :src="item.fileKeyUrl" alt=""></li>
        </ul>

      <el-dialog  title="图片展示" :visible.sync="dialogVisible" center>
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
      </div>
      </div>
      </div>

      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa  fa-stack-overflow iconFont" aria-hidden="true"></i>货物明细</span>
        </h4>
        <div>
          <el-table :data="goodform.sBillWayProductList"  ref="table"    bordersize="mini"
       style="width: 100%" center>
        <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>

        <el-table-column property="cargoBarcode" width="200" label="捆包号"></el-table-column>
          <el-table-column property="productTypeName" width="100" label="货物类型"></el-table-column>

          <el-table-column property="productName"  width="140"  label="品名"></el-table-column>
          <el-table-column property="model" width="120" label="材质"></el-table-column>
          <el-table-column property="specification" width="140"  label="规格"></el-table-column>
          <el-table-column property="number" width="140"  label="件数"></el-table-column>
          <el-table-column property="weight" width="100" label="重量(吨)"></el-table-column>
          <el-table-column property="contractNumber" width="120" label="合同号"></el-table-column>
          <el-table-column property="agreementNumber" width="120" label="合约号"></el-table-column>
          <el-table-column property="cargoLocation" width="150" label="货位"></el-table-column>
          <el-table-column property="status" label="状态" >
          <template scope="scope">
            {{[ "未配货","已配货", "已出库","已收货"][scope.row.status-1]}}
          </template>
        </el-table-column>
          <el-table-column  width="160" :formatter="dateFormat" property="enterTime" label="入库时间"></el-table-column>
      </el-table>
        </div>
      </div>
   </el-form>

  </div>
</template>

<script>
import { SBLdetail } from '@/api/soc-customer'
export default {
  data () {
    let id = this.$route.query.id
    return {
      id: id,
      jjfangshi: [
        { val: 1, name: '按吨' },
        { val: 2, name: '包干' }
      ],
      jsfangshi: [
        { val: 1, name: '电汇' },
        { val: 2, name: '现金' },
        { val: 3, name: '其他' }
      ],
      dialogVisible: false,
      dialogImageUrl: '',
      goodform: {}
    }
  },
  created () {
    SBLdetail({ id: this.id }).then(res => {
      this.goodform = res
    })
  },
  watch: {

  },
  methods: {
    lookImg (n) {
      this.dialogVisible = true
      this.dialogImageUrl = this.goodform.sBillFileList[n].fileKeyUrl
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = ''
      } else {
        str = t.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minutes + ':' + seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>

.imgBox{
  margin: 22px 10px;
  ul{
    display: flex;
    padding-left: 0;
    li{
         width: 160px;
    height: 160px;
    list-style: none;
    margin-right: 10px;
      img{
        width:100%;
        height:100%
      }
    }
  }
}
.inpBox  /deep/.el-input__inner{
  border:none;
  padding: 0;
  color:#333;
}
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form-item--mini.el-form-item{
    margin-bottom: 0px;
}
/deep/.el-input.is-disabled .el-input__inner{
  background: #fff;
}
 /deep/.el-input__suffix, /deep/.el-input__icon{
   display: none;
 }
 .danwei{
   /deep/ .el-input__inner{
         width: 300px;
    overflow: auto;
   }
 }

</style>
